<div id="idx+'table'" #dataTable class="w-100 d-flex flex-column common-table">
 @if(!dataSource.data){
   <p>No Data given in Table</p>
 }
  <div class="table-wrapper mat-elevation-z8">
    <div class="visually-hidden">Hidden Text</div>
    <table mat-table role="table"
      [dataSource]="dataSource"
      matSort (matSortChange)="sortData($event)"
      matSortDisableClear
      [matSortDisabled]="!tableConfig?.tableSort?.enableSorting"
      [matSortActive]="tableConfig?.tableSort?.sortActive || ''"
      [matSortDirection]="tableConfig?.tableSort?.sortDirection || 'asc'"
      [multiTemplateDataRows]="rowExpandable">
    <!-- All Data Columns in a for loop-->
    @for(column of tableConfig.columns; track column){
      <ng-container [matColumnDef]="column.columnDef">
      <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="{'width':column.columnWidth}" role="columnheader">
        <div class="column-title" style="margin: 0;"> {{column.columnTitle}} </div>
      </th>
      @if(rowExpandable){
        <td class="mat-body-2" mat-cell *matCellDef="let element; let i = dataIndex" role="cell">
          <!-- Default template for data elements -->
          <ng-template #defaultElement let-element let-column="col" let-idx="idx">
            {{element[column.dataKey]}}
          </ng-template>
          <!-- Data set in td through template -->
          <ng-container
          [ngTemplateOutlet]="dataTemplate || defaultElement"
          [ngTemplateOutletContext]="{ $implicit: element, col: column, idx: i+1 }">
          </ng-container>
        </td>
      }@else{
        <td class="mat-body-2" mat-cell *matCellDef="let element; let i = index" role="cell">
          <!-- Default template for data elements -->
          <ng-template #defaultElement let-element let-column="col" let-idx="idx">
            {{element[column.dataKey]}}
          </ng-template>
          <!-- Data set in td through template -->
          <ng-container
          [ngTemplateOutlet]="dataTemplate || defaultElement"
          [ngTemplateOutletContext]="{ $implicit: element, col: column, idx: i+1 }">
          </ng-container>
        </td>
      }
    </ng-container>
    }

    <!-- Expand toggle Column -->
    @if(rowExpandable){
      <ng-container matColumnDef="expand">
      <th style="width: 10%;" class="column-title" mat-header-cell *matHeaderCellDef role="columnheader">
        <span class="visually-hidden">Expand/Collapse</span> <span>&nbsp;</span>
      </th>
      <td mat-cell *matCellDef="let element; let i = dataIndex" role="cell">
        <button mat-icon-button [attr.aria-expanded]="expandedElement === element" attr.aria-labelledby="expIcon{{i+1}}"
        (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
          
          @if(expandedElement === element){
            <mat-icon aria-label="lessInfo" class="exp-toggle-icon-up"  id="expIcon{{i+1}}"></mat-icon>
          }@else{
            <mat-icon aria-label="moreInfo" class="exp-toggle-icon-down" id="expIcon{{i+1}}"></mat-icon>
          }
        </button>
      </td>
    </ng-container>
    }

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
   @if(rowExpandable){
     <ng-container matColumnDef="expandedDetail">
      <td style="padding: 0 1rem;" mat-cell *matCellDef="let element; let i = dataIndex"
      [attr.colspan]="columnsToDisplay.length" role="columnheader">
        @if(element === expandedElement){
          <div [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
          <ng-template #defaultTemplate let-element let-idx="rowIndex">
            <p class="w-100 text-center">Expanded View for rowIndex : {{idx}}</p>
          </ng-template>
          <ng-container
                [ngTemplateOutlet]="expandTemplate || defaultTemplate"
                [ngTemplateOutletContext]="{$implicit:element, rowIndex:i+1}">
          </ng-container>
        </div>
        }
      </td>
    </ng-container>
   }

    <tr role="row" mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <!-- tr for expandable rows -->
    @if(rowExpandable){
      <ng-container>
      <tr role="row" mat-row *matRowDef="let element; columns: columnsToDisplay;"
      class="example-element-row" [class.example-expanded-row]="expandedElement === element"></tr>
      <tr role="row" style="height: 0px;" mat-row *matRowDef="let element; columns: ['expandedDetail'];"></tr>
    </ng-container>
    }
    <!-- tr for normal rows -->
    @if(!rowExpandable){
      <ng-container>
      <tr role="row" mat-row *matRowDef="let element; columns: columnsToDisplay;"></tr>
    </ng-container>
    }
    </table>
  </div>
  @if(tableConfig?.pagination?.showPagination){
    <div id="pag" #pag class="w-100 d-flex flex-row mat-elevation-z8">
    <mat-paginator #paginator class="common-paginator"
      [hidePageSize]="!tableConfig?.pagination?.showPageSize"
      [pageSizeOptions]="tableConfig?.pagination?.pageSizeOptions || [5,10]"
    [showFirstLastButtons]="tableConfig?.pagination?.showFirstLastButtons">
    </mat-paginator>
  </div>
  }
</div>
